/**
 * Merges Tailwind CSS classes with conflict resolution.
 *
 * Without this, competing classes like "px-2 px-4" would both apply
 * and the winner depends on CSS source order, not the order you wrote
 * them. twMerge ensures the last one wins, which is what you expect
 * when conditionally applying styles in JSX.
 *
 * Used by every component in ui/ to safely compose class names.
 */
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
